<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcEntityRegistrationForm',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: null,
            additionalActivityIndex: -1,
        };
    },

    created() {
        this.model = new FormModel(this.initialData);
    },

    methods: {
        addSupplier() {
            this.model.$.suppliers.push({
                title: '',
            });
        },

        removeSupplier(supplier) {
            this.model.$.suppliers = this.model.$.suppliers.filter(s => s !== supplier);
        },

        addBuyer() {
            this.model.$.buyers.push({
                title: '',
            });
        },

        removeBuyer(buyer) {
            this.model.$.buyers = this.model.$.buyers.filter(b => b !== buyer);
        },

        addCountry() {
            this.model.$.activity_countries.push({
                title: '',
            });
        },

        removeCountry(country) {
            this.model.$.activity_countries = this.model.$.activity_countries.filter(b => b !== country);
        },

        addAdditionalActivity() {
            this.model.$.additional_activities.push({
                id: this.additionalActivityIndex--,
                activity_classification_id: null,
                activity_licensed: 0,
            });
        },

        removeAdditionalActivity(activity) {
            this.model.$.additional_activities = this.model.$.additional_activities.filter(b => b !== activity);
        },

        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('', this.model.$);
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },
    },
};
</script>
